import {
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_SM,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_250,
	SYS_SPACE_FIXED_300,
	SYS_SPACE_FIXED_400,
	SYS_SPACE_FIXED_450,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';
import { ConfigurationStepStyle } from '~/app/compositions/sidebar/trim-line/styles/selection-step-section-style';
import { mobileBreakPoint } from '~/styles/break-points';

export const AccessoriesConfigurationStepStyle = styled(ConfigurationStepStyle)`
	padding-bottom: 0;
	padding-top: 0;

	.selection-step {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_300};

		#accessories {
			margin-bottom: 0;
		}

		.button-tabs-container {
			margin: 0;
			padding: 0;
		}

		.search-accessories {
			@media (min-width: ${mobileBreakPoint}px) {
				padding-bottom: ${SYS_SPACE_FIXED_300};
			}
		}

		@media (min-width: ${mobileBreakPoint}px) {
			position: sticky;
			top: 0;
			padding-bottom: 72px;
			padding-top: 36px;
		}
	}
`;

export const AccessoriesSelectionStepStyle = styled.section`
	display: flex;
	flex-direction: column;
	max-width: 100vw;
	width: 100%;
	@media (min-width: ${mobileBreakPoint}px) {
		flex-direction: row-reverse;
	}

	.equipment-container {
		padding-top: 0;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
		grid-auto-rows: min-content;
		gap: ${SYS_SPACE_FIXED_250};
		height: fit-content;
		width: 100%;

		@media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
			padding-left: ${SYS_PAGE_MARGIN_SM};
			padding-right: ${SYS_PAGE_MARGIN_SM};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
			padding-left: ${SYS_PAGE_MARGIN_MD};
			padding-right: ${SYS_PAGE_MARGIN_MD};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
			padding-left: ${SYS_PAGE_MARGIN_LG};
			padding-right: ${SYS_PAGE_MARGIN_LG};
		}

		@media (min-width: ${mobileBreakPoint}px) {
			padding-top: ${SYS_SPACE_FIXED_450};
			padding-right: 0;
		}

		.pagination-items {
			margin-top: ${SYS_SPACE_FIXED_450};
			grid-column: 1 / -1;
			display: flex;
			flex-direction: column;
			gap: ${SYS_SPACE_FIXED_150};
			place-items: center;

			.pagination-button {
				width: 100%;

				@media (min-width: ${mobileBreakPoint}px) {
					width: auto;
				}
			}
		}
	}
`;

export const NoResultContainer = styled.div`
	padding: 1.5rem;
	width: 100%;
	grid-column: 1 / -1;
	white-space: pre-line;
	h4 {
		margin-bottom: ${SYS_SPACE_FIXED_150};
	}
	button {
		margin-top: ${SYS_SPACE_FIXED_400};
	}
`;
